import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EditReferrals from "../../components/Referral/EditReferral";


const EditReferralsPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Referral  </h5><Breadcrumb title="Edit Referral" /></div>


        {/* UsersListLayer */}
        <EditReferrals />


    </>
  );
};

export default EditReferralsPage; 